import script from "./bindDoc.vue?vue&type=script&setup=true&lang=js"
export * from "./bindDoc.vue?vue&type=script&setup=true&lang=js"

import "./bindDoc.vue?vue&type=style&index=0&id=26906fdc&lang=scss"
import "./bindDoc.vue?vue&type=style&index=1&id=26906fdc&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26906fdc"]])

export default __exports__